import React from "react";
import "../styles/ColorTheoryDiagrams.css";

export const ColorPsychologyGrid = () => {
  const colors = [
    {
      name: "Red",
      color: "#FF0000",
      attributes: ["Excitement", "Strength", "Love", "Energy"],
    },
    {
      name: "Orange",
      color: "#FF8C00",
      attributes: ["Confidence", "Success", "Bravery", "Sociability"],
    },
    {
      name: "Yellow",
      color: "#FFD700",
      attributes: ["Creativity", "Happiness", "Warmth", "Cheer"],
    },
    {
      name: "Green",
      color: "#008000",
      attributes: ["Nature", "Healing", "Freshness", "Quality"],
    },
    {
      name: "Blue",
      color: "#0000FF",
      attributes: ["Trust", "Peace", "Loyalty", "Competence"],
    },
    {
      name: "Pink",
      color: "#FF69B4",
      attributes: ["Compassion", "Sincerity", "Sophistication", "Sweet"],
    },
    {
      name: "Purple",
      color: "#800080",
      attributes: ["Royalty", "Luxury", "Spirituality", "Ambition"],
    },
    {
      name: "Brown",
      color: "#8B4513",
      attributes: ["Dependable", "Rugged", "Trustworthy", "Simple"],
    },
    {
      name: "Black",
      color: "#000000",
      attributes: ["Formality", "Dramatic", "Sophistication", "Security"],
    },
    {
      name: "White",
      color: "#FFFFFF",
      attributes: ["Clean", "Simplicity", "Innocence", "Honest"],
    },
  ];

  return (
    <div className="color-psychology-grid">
      {colors.map((item, index) => (
        <div
          key={index}
          className="color-card"
          style={{ backgroundColor: item.color }}
        >
          <h3
            style={{
              color:
                item.color === "#FFFFFF" || item.color === "#FFD700"
                  ? "#000000"
                  : "#FFFFFF",
            }}
          >
            {item.name}
          </h3>
          <ul
            style={{
              color:
                item.color === "#FFFFFF" || item.color === "#FFD700"
                  ? "#000000"
                  : "#FFFFFF",
            }}
          >
            {item.attributes.map((attr, i) => (
              <li key={i}>{attr}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export const ColorTheoryWheel = () => {
  const relationships = [
    {
      name: "ANALOGOUS",
      colors: ["#FF0000", "#FF8000", "#FFFF00"],
    },
    {
      name: "TRIADIC",
      colors: ["#FF0000", "#00FF00", "#0000FF"],
    },
    {
      name: "COMPLEMENTARY",
      colors: ["#FF0000", "#00FFFF"],
    },
    {
      name: "SQUARE",
      colors: ["#FF0000", "#00FF00", "#0000FF", "#FF00FF"],
    },
  ];

  return (
    <div className="color-theory-container">
      <div className="color-wheel">
        {/* SVG Color Wheel */}
        <svg viewBox="0 0 200 200">
          <defs>
            {/* Gradient definitions for the color wheel */}
            <linearGradient id="red-yellow" gradientTransform="rotate(0)">
              <stop offset="0%" stopColor="#FF0000" />
              <stop offset="100%" stopColor="#FFFF00" />
            </linearGradient>
            <linearGradient id="yellow-green" gradientTransform="rotate(120)">
              <stop offset="0%" stopColor="#FFFF00" />
              <stop offset="100%" stopColor="#00FF00" />
            </linearGradient>
            <linearGradient id="green-blue" gradientTransform="rotate(240)">
              <stop offset="0%" stopColor="#00FF00" />
              <stop offset="100%" stopColor="#0000FF" />
            </linearGradient>
          </defs>
          <circle cx="100" cy="100" r="90" fill="url(#red-yellow)" />
          <circle cx="100" cy="100" r="90" fill="url(#yellow-green)" />
          <circle cx="100" cy="100" r="90" fill="url(#green-blue)" />
        </svg>
      </div>

      <div className="color-relationships">
        {relationships.map((rel, index) => (
          <div key={index} className="relationship-group">
            <h4>{rel.name}</h4>
            <div className="color-strip">
              {rel.colors.map((color, i) => (
                <div
                  key={i}
                  className="color-sample"
                  style={{ backgroundColor: color }}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="color-modes">
        <div className="mode rgb">
          <h4>RGB (Additive)</h4>
          <div className="mode-circles">
            <div className="circle red"></div>
            <div className="circle green"></div>
            <div className="circle blue"></div>
          </div>
        </div>
        <div className="mode cmyk">
          <h4>CMYK (Subtractive)</h4>
          <div className="mode-circles">
            <div className="circle cyan"></div>
            <div className="circle magenta"></div>
            <div className="circle yellow"></div>
            <div className="circle black"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
